import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import { computed, provide, toRefs } from 'vue';

import { useBookTicker, type BookTickProvider } from '@exchange/libs/book-ticker/service/src';
import useBreakpoints from '@exchange/libs/composables/shared/src/lib/useBreakpoints';
import useMQBreakpoints from '@exchange/libs/composables/shared/src/lib/useMQBreakpoints';
import { futuresService } from '@exchange/libs/futures/service/src/index';
import { useFutures } from '@exchange/libs/futures/ui/src/lib/useFutures';
import { handleClosePosition } from '@exchange/libs/order/my-orders/service/src/lib/positions.service';

import OpenPositionsListMobile from './mobile/OpenPositionsListMobile.vue';
import OpenPositionsListDesktop from './OpenPositionsListDesktop.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'OpenPositions',
  props: {
  authenticatedUser: { type: Boolean, required: true },
  dragging: { type: Boolean, required: true },
  marketId: { type: String, required: true },
  showAllMarkets: { type: Boolean, required: true },
},
  setup(__props) {

const props = __props;

const { marketId, showAllMarkets } = toRefs(props);
const { getFuturesPositions: futuresPositions } = useFutures(marketId, showAllMarkets);

// Subscribe to book tickers for all positions
const activeMarkets = computed(() => Array.from(new Set(futuresPositions.value.map((position) => position.instrument_code))));
const { getBookTickForMarketId } = useBookTicker(activeMarkets);

const bookTickProvider: BookTickProvider = { getBookTickForMarketId };
provide('bookTickProvider', bookTickProvider);
const { leverage: maxLeverage } = futuresService;

const breakpoints = {
  780: 'hide-type compact-side hide-currency compact-status', // 'compact-side compact-order-type hide-time hide-currency compact-status compact-order-type',
  850: 'hide-type compact-side', // 'compact-side compact-order-type hide-time compact-order-type',
  880: 'hide-type compact-side', // 'compact-side compact-order-type compact-order-type',
  920: 'hide-type compact-side', // 'compact-side compact-order-type',
  bigger: 'hide-type',
};

/* eslint-disable compat/compat */
// @ts-ignore Wait for a proper Houdini API support
const { currentBreakPoint, watchedEl: wrapperRef } = useBreakpoints(breakpoints);

const { isXS } = useMQBreakpoints();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "wrapperRef",
    ref: wrapperRef,
    class: "open-positions"
  }, [
    (!_unref(isXS))
      ? (_openBlock(), _createBlock(OpenPositionsListDesktop, {
          key: 0,
          class: "open-positions__list",
          "show-order-type": false,
          breakpoint: _unref(currentBreakPoint),
          dragging: __props.dragging,
          "market-id": _unref(marketId),
          "show-all-markets": _unref(showAllMarkets),
          "authenticated-user": __props.authenticatedUser,
          "max-leverage": _unref(maxLeverage),
          "futures-positions": _unref(futuresPositions),
          onClosePosition: _unref(handleClosePosition)
        }, null, 8, ["breakpoint", "dragging", "market-id", "show-all-markets", "authenticated-user", "max-leverage", "futures-positions", "onClosePosition"]))
      : (_openBlock(), _createBlock(OpenPositionsListMobile, {
          key: 1,
          class: "open-positions__list",
          "market-id": _unref(marketId),
          "show-all-markets": _unref(showAllMarkets),
          "authenticated-user": __props.authenticatedUser,
          "max-leverage": _unref(maxLeverage),
          "futures-positions": _unref(futuresPositions),
          onClosePosition: _unref(handleClosePosition)
        }, null, 8, ["market-id", "show-all-markets", "authenticated-user", "max-leverage", "futures-positions", "onClosePosition"]))
  ], 512))
}
}

})